import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'; // "react-router-dom" v5.3.4
import './components/@vuexy/rippleButton/RippleButton';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'prismjs/themes/prism-tomorrow.css';
import 'react-toggle/style.css';
import './assets/scss/plugins/forms/switch/react-toggle.scss';
import { ToastContainer } from 'react-toastify';
import Router from './router/router.component';
import CookieNotice from './components/@servierbar/alerts/cookies-notice/cookie-notice.component';
import UpdateAlertComponent from './components/@servierbar/alerts/update-alert/update-alert.component';
import 'moment/min/locales';
import {
  setRequestDefaults,
  setColorVars,
  getImageUrl,
  getImageVariant,
  getBrowserLocale,
} from './utility/util/util.service';
import { useAuth0 } from '@auth0/auth0-react';
import { adoptGuest } from './utility/sb-api/sb-api.service';
import {
  fetchOnAuthenticated,
  fetchOnUnauthenticated,
  fetchOrders,
} from './redux/me/me.actions';
import {
  fetchOnAppEntry,
  fetchOnAdminAppEntry,
  setCheckout,
  setCart,
  setOrder,
  setAvailableOrderTypes,
} from './redux/store/store.actions';
import MoreSettingsModal from './components/@servierbar/modals/more-settings/more-settings.component';
import ListOrdersModal from './components/@servierbar/modals/list-orders/list-orders.component';
import SetFiltersModal from './components/@servierbar/modals/set-filters/set-filters.component';
import OrderInfoModal from './components/@servierbar/modals/order-info/order-info.component';
import { unClosableNotification } from './utility/notification/notification.service';
import { useIntl } from 'react-intl';
import CreateOrEditTableModal from './components/@servierbar/modals/create-or-edit-table/create-or-edit-table.component';
import CreateOrEditPrinterModal from './components/@servierbar/modals/create-or-edit-printer/create-or-edit-printer.component';
import ListPaymentMethodsModal from './components/@servierbar/modals/list-payment-methods/list-payment-methods.component';
import EditMenuEntryCategoryModal from './components/@servierbar/modals/edit-menu-entry-category/edit-menu-entry-category.component';
import ListAddressesModal from './components/@servierbar/modals/list-addresses/list-addresses.component';
import CreateOrEditAddressModal from './components/@servierbar/modals/create-or-edit-address/create-or-edit-address.component';
import SelectBillingAddressComponent from './components/@servierbar/modals/select-billing-address/select-billing-address.component';
import CreateOrEditInfoModal from './components/@servierbar/modals/create-or-edit-info-menu-entry/create-or-edit-info-menu-entry.component';
import './assets/scss/themes/whitelabel-stores.css';
import { SocketContext } from './context/socket.context';
import TagManager from 'react-gtm-module/dist/TagManager';
import {
  setIsAreYouStillThereModalOpen,
  setIsSelfServiceTableSelectionModalOpen,
  setIsSignUpNoticeModalOpen,
} from './redux/modal/modal.actions';
import SignUpNoticeModal from './components/@servierbar/modals/sign-up-notice/sign-up-notice.component';
import UserSettingsComponent from './components/@servierbar/modals/user-settings/user-settings.component';
import { history } from './history';
import Lottie from 'lottie-react';
import handWink from '../src/assets/lottie/hand-wink.json';
import AreYouStillHereComponent from './components/@servierbar/modals/are-you-still-there-modal/are-you-still-here.component';

const App = ({
  store,
  me,
  kiosk,

  fetchOnAuthenticated,
  fetchOnUnauthenticated,
  fetchOnAppEntry,
  fetchOrders,
  fetchOnAdminAppEntry,
  setIsAreYouStillThereModalOpen,
  setIsSelfServiceTableSelectionModalOpen,
}) => {
  const { isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();

  const guestToken = localStorage.getItem('guestToken');

  const intl = useIntl();
  const socket = useContext(SocketContext);
  const inactivityTimeout = useRef(null);
  const inactivityDuration = 30 * 1000; // 30 seconds
  const hasOpenedSelfServiceModal = useRef(false); // Track if self-service modal has been opened

  const [displayAdminNotification, setDisplayAdminNotification] = useState(
    true,
  );
  const [showScreensaver, setShowScreensaver] = useState(false); // New state for screensaver

  // Reset timeout when there is user activit

  const resetInactivityTimeout = () => {
    if (inactivityTimeout.current) {
      clearTimeout(inactivityTimeout.current);
    }
    inactivityTimeout.current = setTimeout(() => {
      setIsAreYouStillThereModalOpen(true);
    }, inactivityDuration);
  };

  const handleAreYouStillThereApprove = () => {
    resetInactivityTimeout();
  };

  const handleUserActivity = () => {
    resetInactivityTimeout();
    setShowScreensaver(false);
  };

  // Global listener for inactivity
  useEffect(() => {
    if (kiosk && history) {
      const events = ['click'];

      events.forEach((event) =>
        window.addEventListener(event, handleUserActivity),
      );

      resetInactivityTimeout(); // Initialize the timeout

      return () => {
        events.forEach((event) =>
          window.removeEventListener(event, handleUserActivity),
        );
        if (inactivityTimeout.current) {
          clearTimeout(inactivityTimeout.current);
        }
      };
    }
  }, [kiosk]);

  useEffect(() => {
    const gtm = store?.merchantProfile?.peripheralIntegrations?.find(
      (integration) =>
        integration?.type === 'GoogleTagManagerPeripheralIntegration',
    );
    if (gtm) {
      const tagManagerArgs = {
        gtmId: gtm.id,
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, [store]);

  useEffect(() => {
    if (kiosk && store?.enableSelfServiceTableSelection) {
      setIsSelfServiceTableSelectionModalOpen(true);
      hasOpenedSelfServiceModal.current = true; // Mark as opened so it won't open again
    }
  }, [store, kiosk, setIsSelfServiceTableSelectionModalOpen]);

  useEffect(() => {
    if (!isLoading) {
      (isAuthenticated
        ? getAccessTokenSilently().then((token) => {
            setRequestDefaults(token, false, socket.setToken);
            const adoptGuestMode = localStorage.getItem('adoptGuestMode');

            if (guestToken && adoptGuestMode === 'yes') {
              return adoptGuest().then(() => ({ isAuthenticated: true }));
            } else {
              if (guestToken) {
                localStorage.setItem('guestTokenBackup', guestToken);
                localStorage.removeItem('guestToken');
              }
              return Promise.resolve({ isAuthenticated: true });
            }
          })
        : guestToken
        ? Promise.resolve().then(() => {
            setRequestDefaults(guestToken, true, socket.setToken);
            return Promise.resolve({ isAuthenticated: true });
          })
        : Promise.resolve({ isAuthenticated: false })
      ).then(({ isAuthenticated }) => {
        if (isAuthenticated) {
          fetchOnAuthenticated();
        } else {
          fetchOnUnauthenticated();
        }
        fetchOnAppEntry();
      });
    }
  }, [
    fetchOnAppEntry,
    fetchOnAuthenticated,
    fetchOnUnauthenticated,
    fetchOrders,
    getAccessTokenSilently,
    guestToken,
    isAuthenticated,
    isLoading,
  ]);

  useEffect(() => {
    if (me?.isAdmin) {
      if (
        me?.isOnBehalfOfStore &&
        store?.id === me?.requester?.employeeProfile?.store?.id &&
        displayAdminNotification
      ) {
        unClosableNotification(
          'warning',
          intl.formatMessage(
            { id: 'loggedOnBehalfOfStoreOwner' },
            { storeName: store?.name },
          ),
        );
        setDisplayAdminNotification(false);
      }
      fetchOnAdminAppEntry();
    }
  }, [me, store]);

  useEffect(() => {
    setColorVars(store);
  }, [store]);

  useEffect(() => {
    const handleTouchMove = (event) => {
      if (event.touches && event.touches.length >= 2) {
        event.preventDefault();
      }
    };
    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  const translations = useMemo(
    () => [
      { lang: 'de', text: 'Bestelle hier!' },
      { lang: 'en', text: 'Order here!' },
      { lang: 'fr', text: 'Commandez ici!' },
      { lang: 'es', text: '¡Ordena aquí!' },
      { lang: 'it', text: 'Ordina qui!' },
      { lang: 'hu', text: 'Rendelj itt!' },
    ],
    [],
  );
  const ScreensaverMessage = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animationClass, setAnimationClass] = useState('animate__fadeIn');

    useEffect(() => {
      const animationInterval = setInterval(() => {
        setAnimationClass('animate__fadeOut'); // Trigger fade-out animation
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % translations.length);
          setAnimationClass('animate__fadeIn'); // Reset to fade-in animation
        }, 1000); // Fade-out duration (matches animation duration in CSS)
      }, 3000); // Total interval for each translation (3 seconds)

      return () => clearInterval(animationInterval);
    }, []);

    return (
      <div
        className={`screensaver-message animate__animated ${animationClass}`}
      >
        <h1>{translations[currentIndex].text}</h1>
      </div>
    );
  };

  const handWinkAnimationFull = useMemo(
    () => (
      <Lottie
        style={{
          width: '40%',
          display: 'flex',
          margin: 'auto',
        }}
        animationData={handWink}
        loop={true}
      />
    ),
    [store?.primaryColor],
  );
  return (
    <>
      {showScreensaver && (
        <>
          {kiosk?.backgroundImage ? (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url('${getImageUrl(
                  kiosk.backgroundImage,
                  getImageVariant('kioskBackgroundImage'),
                )}')`,
                backgroundSize: '100%',
                color: 'white',
                zIndex: 9999,
              }}
              className="d-flex flex-column justify-content-center"
            >
              <div className="screensaver-message p-1 text-center">
                <div>
                  {handWinkAnimationFull}
                  <ScreensaverMessage />
                </div>
              </div>
            </div>
          ) : (
            <div className="screensaver-overlay d-flex flex-column justify-content-center">
              <div className="screensaver-message p-1 text-center">
                <div>
                  {handWinkAnimationFull}
                  <ScreensaverMessage />
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Router>
        <ToastContainer />
        <UpdateAlertComponent />
        {!kiosk && <CookieNotice />}
        <SignUpNoticeModal />

        <CreateOrEditPrinterModal />
        <SetFiltersModal />
        <MoreSettingsModal />
        <ListOrdersModal />
        <OrderInfoModal />
        <CreateOrEditTableModal />
        <ListPaymentMethodsModal />
        <EditMenuEntryCategoryModal />
        <ListAddressesModal />
        <UserSettingsComponent />
        <CreateOrEditAddressModal />
        <SelectBillingAddressComponent />
        <CreateOrEditInfoModal />
        <AreYouStillHereComponent
          onTimeout={() => setShowScreensaver(true)}
          onApprove={handleAreYouStillThereApprove}
        />
      </Router>
    </>
  );
};

const mapStateToProps = (state) => ({
  store: state.store.store,
  kiosk: state.store.kiosk,
  table: state.store.table,
  cart: state.store.cart,
  checkout: state.store.checkout,
  me: state.me.me,
});

export default connect(mapStateToProps, {
  fetchOnAppEntry,
  fetchOrders,
  fetchOnAuthenticated,
  fetchOnUnauthenticated,
  fetchOnAdminAppEntry,
  setIsSignUpNoticeModalOpen,
  setCheckout,
  setCart,
  setOrder,
  setAvailableOrderTypes,
  setIsSelfServiceTableSelectionModalOpen,
  setIsAreYouStillThereModalOpen,
})(App);
